import { render, staticRenderFns } from "./recipient-type.vue?vue&type=template&id=42696119&scoped=true&"
import script from "./recipient-type.vue?vue&type=script&lang=js&"
export * from "./recipient-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42696119",
  null
  
)

export default component.exports